// @ts-nocheck
/* eslint-disable react/prop-types */

import React, {
	createContext,
	useContext,
	useEffect,
	useMemo,
	useState,
} from 'react';
import { useTranslation } from 'react-i18next';

const headDefaultValue = {
	title: '',
	subtitle: '',
	buttons: [],
	menu: '',
	isHidden: false,
	isHiddenBreadcrumb: true,
};

const contextDefaultValue = {
	head: headDefaultValue,
	setHead: () => undefined,
};

const HeadContext = createContext(contextDefaultValue);

const HeadProvider = ({ children }) => {
	const [head, setHead] = useState(headDefaultValue);
	const { i18n } = useTranslation();


	useEffect(() => {
		window.addEventListener('message', (e) => console.log(e));
	}, []);

	useEffect(() => {
		const sessionLanguage = localStorage.getItem('preferredLanguage') ?? 'es_ES';
		if (sessionLanguage !== 'es_ES') {
			i18n.changeLanguage(sessionLanguage.slice(0, 2));
		}
	}, [i18n]);

	const value = useMemo(
		() => ({
			head,
			setHead,
		}),
		[head]
	);

	return (
		<HeadContext.Provider value={value}>
			{children}
		</HeadContext.Provider>
	);
};

const useHead = () => {
	const context = useContext(HeadContext);

	if (!context) {
		throw new Error('useHead must be used within provider');
	}

	return context;
};

export { HeadContext, HeadProvider, useHead };
